export const galleryImages = [
  // Accommodations
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca-1350x581.jpg",
    alt: "Tendas Toca — Vista Geral / Overview",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-2-camping-pods.jpg",
    alt: "Tendas Toca — 2 Camping Pods",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_front-view.jpg",
    alt: "Tendas Toca — Vista Frontal / Front View",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_master-bed.jpg",
    alt: "Tendas Toca — Cama Master / Master Bed",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-to-pool.jpg",
    alt: "Tendas Toca — Vista Piscina / Pool View",
    category: "nature",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal.jpg",
    alt: "Cabanas O Figo — Vista Geral / Overview",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_terrace-1.jpg",
    alt: "Cabanas O Figo — Terraço / Terrace",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_front-view-1.jpg",
    alt: "Cabanas O Figo — Vista Frontal / Front View",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_garden-1.jpg",
    alt: "Cabanas O Figo — Jardim / Garden",
    category: "nature",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_kichinette-1.jpg",
    alt: "Cabanas O Figo — Kitchenette",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-Figo-cabin-3-persons-1.jpg",
    alt: "Cabanas O Figo — Cabana Interior",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho-02.jpg",
    alt: "Cabanas O Medronho — Vista Geral / Overview",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_cabana.jpg",
    alt: "Cabanas O Medronho — Cabana",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_terras.jpg",
    alt: "Cabanas O Medronho — Terraço / Terrace",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_garden.jpg",
    alt: "Cabanas O Medronho — Jardim / Garden",
    category: "nature",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_kids-cabin.jpg",
    alt: "Cabanas O Medronho — Cabana Crianças / Kids Cabin",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-medronho-cabin-4-persons-1.jpg",
    alt: "Cabanas O Medronho — 4 Pessoas / 4 Persons",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford.jpg",
    alt: "Rode Ford 1972 — Vista Geral / Overview",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_front-view.jpg",
    alt: "Rode Ford 1972 — Vista Frontal / Front View",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_night.jpg",
    alt: "Rode Ford 1972 — À Noite / At Night",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_terrace.jpg",
    alt: "Rode Ford 1972 — Terraço / Terrace",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_interior.jpg",
    alt: "Rode Ford 1972 — Interior",
    category: "accommodations",
  },
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_detail.jpg",
    alt: "Rode Ford 1972 — Detalhe / Detail",
    category: "accommodations",
  },
  // Nature & Garden
  {
    src: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_kitchen.jpg",
    alt: "Tendas Toca — Cozinha / Kitchen",
    category: "accommodations",
  },
  // Location
  ];

export const categoryKeys = {
  pt: {
    all: "Todos",
    accommodations: "Acomodações",
    nature: "Natureza & Jardim",
    location: "Localização",
  },
  en: {
    all: "All",
    accommodations: "Accommodations",
    nature: "Nature & Garden",
    location: "Location",
  },
};
